import { hotSearch } from "@/mocks/hotSearch";
import { formatHeat } from "@/utils/format";

const STATS = [
  { label: "今日新增话题", value: "1,284 条" },
  { label: "实时热度峰值", value: "98.6 万" },
  { label: "在场围观人数", value: "32.6 万" },
];

function TrendingTicker() {
  const loop = [...hotSearch, ...hotSearch];
  return (
    <div className="flex items-center gap-4 overflow-hidden py-3">
      <span className="flex shrink-0 items-center gap-2 pl-4 text-xs font-medium text-accent-300 md:pl-8">
        <i className="ri-flashlight-fill" aria-hidden="true" />
        实时热搜
      </span>
      <div className="relative flex-1 overflow-hidden">
        <div className="flex w-max animate-marquee-x items-center gap-8">
          {loop.map((item, index) => (
            <span
              key={`${item.title}-${index}`}
              className="flex shrink-0 items-center gap-2 whitespace-nowrap text-xs text-background-100"
            >
              <span className="font-heading text-sm font-bold text-primary-300">
                {String(item.rank).padStart(2, "0")}
              </span>
              {item.title}
              <span className="text-background-300">{formatHeat(item.heat)}</span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function HeroSection() {
  return (
    <section id="top" className="relative min-h-[92vh] w-full overflow-hidden">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20editorial%20background%20of%20glowing%20bokeh%20lights%20and%20flowing%20gradient%20waves%20in%20coral%20red%20and%20golden%20amber%20tones%2C%20deep%20cinematic%20vignette%20overlay%2C%20sophisticated%20magazine%20cover%20atmosphere%2C%20soft%20film%20grain%20texture%2C%20no%20text&width=1600&height=900&seq=gossip-hero-main&orientation=landscape"
          alt="网曝吃瓜热点围观现场氛围背景"
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/75 via-foreground-950/55 to-foreground-950/85" />

      <div className="relative z-10 flex min-h-[92vh] w-full flex-col justify-center px-4 pb-36 pt-28 md:px-8 md:pb-40">
        <div className="w-full max-w-4xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-accent-400/40 bg-foreground-950/40 px-3.5 py-1.5 text-xs font-medium text-accent-200 backdrop-blur-sm">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-live-pulse rounded-full bg-primary-400" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-400" />
            </span>
            实时围观中 · 刚刚更新
          </span>

          <h1 className="mt-6 font-heading text-3xl font-black leading-tight text-background-50 sm:text-4xl md:text-6xl">
            网曝吃瓜
            <span className="mt-2 block text-xl font-semibold text-background-100 sm:text-2xl md:text-4xl">
              全网热点话题，一屏围观到底
            </span>
          </h1>

          <p className="mt-6 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
            这里聚合当下最热的话题与围观现场，从热搜榜到深度讨论，带你在几分钟内看清热度中心。
            不站队、不跟风，只把正在发生的讨论整理得清清楚楚。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#ranking"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-fire-line" aria-hidden="true" />
              立即看实时热榜
            </a>
            <a
              href="#topics"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 bg-background-50/10 px-6 py-3 text-sm font-medium text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/20"
            >
              <i className="ri-compass-3-line" aria-hidden="true" />
              浏览热门话题
            </a>
          </div>

          <dl className="mt-12 grid grid-cols-1 gap-6 border-t border-background-50/15 pt-8 sm:grid-cols-3">
            {STATS.map((stat) => (
              <div key={stat.label}>
                <dt className="text-xs tracking-wider text-background-300">{stat.label}</dt>
                <dd className="mt-2 font-heading text-2xl font-bold text-accent-300 md:text-3xl">
                  {stat.value}
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>

      <div className="absolute inset-x-0 bottom-0 z-10 border-t border-background-50/15 bg-foreground-950/50 backdrop-blur-sm">
        <TrendingTicker />
      </div>
    </section>
  );
}